import Paragraphs from './Paragraphs'
export default Paragraphs
